import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';

function useRouterLocationState(key, initialValue) {
  const history = useHistory();
  const location = useLocation();

  const value = location.state?.[key] ?? initialValue;

  const setValue = useCallback((next) => {
    const nextValue = next instanceof Function ? next(location.state?.[key] ?? initialValue) : next;
    history.replace(
      { pathname: location.pathname, search: location.search, hash: location.hash },
      { ...location.state, [key]: nextValue },
    );
  }, [history, location, key, initialValue]);

  return [value, setValue];
}

export default useRouterLocationState;
